import { render, staticRenderFns } from "./RecordManualPayment.vue?vue&type=template&id=0a480d87&"
import script from "./RecordManualPayment.vue?vue&type=script&lang=js&"
export * from "./RecordManualPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecordManualPayment.vue"
export default component.exports